import React, { useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
} from "reactstrap";
import CETable from "../../Tables/UsersTable/CETable";

const UserCEModal = ({ open, setOpen, userData, loading }) => {
  const toggleUserModal = () => {
    setOpen(!open);
  };

  return (
    <div>
      <Modal size="lg" isOpen={open} toggle={toggleUserModal}>
        <>
          <ModalHeader toggle={toggleUserModal}>
            Client Eligibility{" "}
          </ModalHeader>
          <ModalBody
            style={{
              overflow: "auto",
            }}
          >
            {loading ? (
              <div className="d-flex justify-content-center align-items-center">
                <Spinner
                  size="xs"
                  color="primary"
                  className="d-flex justify-content-center align-items-center"
                  style={{ width: "3rem", height: "3rem" }}
                />
              </div>
            ) : userData ? (
              <CETable data={[userData]} loading={loading} />
            ) : (
              <div className="d-flex justify-content-center align-items-center">
                <h5>Client Eligibility not found.</h5>
              </div>
            )}
          </ModalBody>
        </>
      </Modal>
    </div>
  );
};

export default UserCEModal;
